const insightKey = ({ url, interval, count, key, download }) => {
  const start = interval.startDate.startOf('day').toISOString();
  const end = interval.endDate.endOf('day').toISOString();
  return [url, start, end, count, key, download ? 'd' : ''].join('|');
};

export default {
  insightKey
};
